module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/babel-runtime/core-js/object/define-property.js
// module id = 204
// module chunks = 0